import React from 'react';

import Header from '@dashboard/components/pages/QueryListPage/PageWrapper/Header';
import { useRequestLogsQuery } from '@dashboard/generated/wp/platform';
import { useCurrentPage } from '@dashboard/hooks/route/useCurrentPage';
import { Box, CircularProgress, Paper, Stack, Typography } from '@mui/material';
import useQueryDataTableProps from '@wp-react/hooks/useQueryDataTableProps';

import ListItem from './ListItem';

type Props = {
  currentRequestId: string | null;
  setCurrentRequestId: (id: string) => void;
};
export default function RequestLogList({ currentRequestId, setCurrentRequestId }: Props) {
  const page = useCurrentPage();
  const { data } = useRequestLogsQuery({ variables: { page } });
  const { pagination } = useQueryDataTableProps(data?.RequestLogs);
  const nodes = data?.RequestLogs.nodes;

  const renderBody = () => {
    if (!nodes) {
      return (
        <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 96 }}>
          <CircularProgress size={32} />
        </Box>
      );
    }

    if (nodes.length === 0) {
      return (
        <Stack spacing={3} sx={{ py: 5 }} alignItems="center" justifyContent="center" textAlign="center" px={2}>
          <Typography color="text.secondary">No API requests.</Typography>
        </Stack>
      );
    }

    return (
      <Box pt={1} sx={{ height: '100%' }}>
        {nodes.map((model) => (
          <ListItem
            key={model.id}
            selected={model.id === currentRequestId}
            onClick={() => setCurrentRequestId(model.id)}
            model={model}
          />
        ))}
      </Box>
    );
  };

  return (
    <Paper>
      <Header title="API Request Logs" pagination={pagination} />
      {renderBody()}
    </Paper>
  );
}
